import React, { useState, useEffect } from 'react';
import styles from '../../styles/PortalEstudiantesStyles/PortalEstudiantes.module.css';

const COOKIE_CONSENT_KEY = 'lux_cookie_consent';

/**
 * Componente de aviso de cookies
 * Muestra un banner en el footer del portal solicitando el consentimiento del usuario
 * para el uso de cookies (almacenamiento local, sesión, analytics, etc.)
 */
function CookieConsent() {
  const [showBanner, setShowBanner] = useState(false);
  const [showOptions, setShowOptions] = useState(false);

  useEffect(() => {
    // Verificar si el usuario ya aceptó las cookies
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY);
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    // Guardar aceptación completa
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: true,
      all: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleReject = () => {
    // Guardar rechazo (solo cookies esenciales)
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: true,
      all: false,
      essential: true,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
  };

  const handleOpenOptions = () => {
    setShowOptions(true);
  };

  const handleCloseOptions = () => {
    setShowOptions(false);
  };

  const handleSavePreferences = (preferences) => {
    localStorage.setItem(COOKIE_CONSENT_KEY, JSON.stringify({
      accepted: true,
      ...preferences,
      timestamp: new Date().toISOString()
    }));
    setShowBanner(false);
    setShowOptions(false);
  };

  if (!showBanner) return null;

  return (
    <>
      {/* Banner de cookies */}
      <div className={styles.cookieBanner}>
        <div className={styles.cookieContent}>
          <p className={styles.cookieText}>
            Usamos cookies en nuestra página web para ver cómo interactúas con ella. 
            Al aceptarlas, estás de acuerdo con nuestro uso de dichas cookies.{' '}
            <a 
              href="https://universidadlux.edu.mx/politica-de-privacidad" 
              target="_blank" 
              rel="noopener noreferrer"
              className={styles.cookieLink}
            >
              Política de privacidad
            </a>
          </p>
          <div className={styles.cookieActions}>
            <button 
              className={styles.cookieButtonSecondary}
              onClick={handleOpenOptions}
            >
              Opciones
            </button>
            <button 
              className={styles.cookieButtonSecondary}
              onClick={handleReject}
            >
              Rechazar todas
            </button>
            <button 
              className={styles.cookieButtonPrimary}
              onClick={handleAccept}
            >
              Aceptar
            </button>
          </div>
        </div>
      </div>

      {/* Modal de opciones de cookies */}
      {showOptions && (
        <div className={styles.cookieModal}>
          <div className={styles.cookieModalContent}>
            <div className={styles.cookieModalHeader}>
              <h3>Configuración de Cookies</h3>
              <button 
                className={styles.cookieModalClose}
                onClick={handleCloseOptions}
              >
                ×
              </button>
            </div>
            <div className={styles.cookieModalBody}>
              <div className={styles.cookieOption}>
                <div className={styles.cookieOptionInfo}>
                  <h4>Cookies esenciales</h4>
                  <p>Necesarias para el funcionamiento básico del sitio (sesión, autenticación).</p>
                </div>
                <span className={styles.cookieRequired}>Requeridas</span>
              </div>
              <div className={styles.cookieOption}>
                <div className={styles.cookieOptionInfo}>
                  <h4>Cookies de análisis</h4>
                  <p>Nos ayudan a entender cómo interactúas con el sitio web.</p>
                </div>
                <label className={styles.cookieSwitch}>
                  <input type="checkbox" id="analytics" defaultChecked />
                  <span className={styles.cookieSlider}></span>
                </label>
              </div>
              <div className={styles.cookieOption}>
                <div className={styles.cookieOptionInfo}>
                  <h4>Cookies de terceros</h4>
                  <p>Utilizadas por servicios externos como Google Maps.</p>
                </div>
                <label className={styles.cookieSwitch}>
                  <input type="checkbox" id="thirdParty" defaultChecked />
                  <span className={styles.cookieSlider}></span>
                </label>
              </div>
            </div>
            <div className={styles.cookieModalFooter}>
              <button 
                className={styles.cookieButtonSecondary}
                onClick={handleReject}
              >
                Rechazar opcionales
              </button>
              <button 
                className={styles.cookieButtonPrimary}
                onClick={() => {
                  const analytics = document.getElementById('analytics')?.checked;
                  const thirdParty = document.getElementById('thirdParty')?.checked;
                  handleSavePreferences({ 
                    essential: true, 
                    analytics, 
                    thirdParty 
                  });
                }}
              >
                Guardar preferencias
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CookieConsent;
